import { render } from "./ReportComponent.vue?vue&type=template&id=58e5023f&scoped=true&ts=true"
import script from "./ReportComponent.vue?vue&type=script&lang=ts"
export * from "./ReportComponent.vue?vue&type=script&lang=ts"

import "./ReportComponent.vue?vue&type=style&index=0&id=58e5023f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58e5023f"]])

export default __exports__